import { getIsAdoptableOfferType, getIsOnSale, getIsPending } from '../../../utils/adoptables';
export function getAdoptableSellerElementGroupBase(deviation, isMobile, isOwner) {
    if (!deviation.isAdoptable || isMobile) {
        return false;
    }
    const isPending = getIsPending(deviation);
    const isOnSale = getIsOnSale(deviation);
    if (// Can't edit a deviation's adoptable sale settings if it isn't on sale
    !isPending && !isOnSale || // Only the current owner can edit an ongoing sale
    !isOwner) {
        return false;
    }
    const isOfferType = getIsAdoptableOfferType(deviation);
    const result = {
        endSale: true,
        viewOffers: isOfferType
    };
    return result;
}

//# sourceMappingURL=adoptableSeller.js.map